skyward.base.registerScript("header", function (skyward, $)
{
    skyward.header = skyward.header || {};

    skyward.header.signOutButtonClick = function ()
    {
        $(this).off("click");
        skyward.window.loadContent("full", "Security", "SignIn", "index", null);
    };

    skyward.header.signInButtonClick = function ()
    {
        $(this).off("click");
        skyward.window.loadContent("full", "Security", "SignIn", "index", null);
    };

    skyward.header.applicantTrackingSignInButtonClick = function ()
    {
        const element = $(this);
        element.off("click");
        window.location.href = element.data("redirect-url");
    };

    skyward.header.showHomeButtons = async function (button)
    {
        const html = await $.ajax(
            {
                url: skyward.global.virtualDir + "Home/Home/GetHomeButtons/",
                type: "POST",
                dataType: "viewparthtml"
            });

        if ($(html).find(`.${classNames.portalHomeButton}`).length < 2)
        {
            skyward.window.checkLoadContent("full", "home", "home", "index");
            return;
        }

        const dialog = skyward.modalLayer.showInformationBubble("Home", html, null, { anchorTo: button, useSmallWidth: true, role: "menu" });

        dialog.content.find(`.${classNames.portalHomeButton}`).on("click", function ()
        {
            dialog.close();
            skyward.window.checkLoadContent("full", "Home", "Home", "PortalIndex", null, { PortalCode: $(this).data().portalcode });
        });
    };

    const classNames =
    {
        displayNone: "displayNone",
        portalHomeButton: "portalHomeButton",
        ribbon: "ribbon",
        ribbonCompressed: "ribbon--compressed"
    };
    Object.freeze(classNames);

    const idNames =
    {
        compressMode: "compressMode",
        externalLinks: "externalLinks",
        importSelector: "importSelector",
        portalButton: "portalButton",
        quickNav: "quickNav",
        reportAndImportSelector: "reportAndImportSelector",
        reportSelector: "reportSelector",
        signOutButton: "signOutButton",
        signInButton: "signInButton",
        applicantTrackingSignInButton: "applicantTrackingSignInButton",
        tileListBrowseLaunch: "tileListBrowseLaunch"
    };
    Object.freeze(idNames);

    const getRibbon = () => $(`.${classNames.ribbon}, .${classNames.ribbonCompressed}`);

    const events =
    {
        init,
        redirectToExternalLink
    };

    return events;

    function init()
    {
        const header = $(this);

        initSignOutButton(header);
        initSignInButton(header);
        initApplicantTrackingSignInButton(header);
        initHomeButton(header);
        initTileListLaunchButton(header);
        initCompressModeButton(header);
        initReportAndImportButtons(header);
        initSkipToMainContent();
    }

    function redirectToExternalLink()
    {
        let url = $(this).data().url;
        if (!url.startsWith("http"))
        {
            url = `//${url}`;
        }
        window.open(url);
    }

    function initSignOutButton(header)
    {
        const signOutButton = header.find(`#${idNames.signOutButton}`);

        if (signOutButton.length)
        {
            signOutButton.one("click", skyward.header.signOutButtonClick);
        }
    }

    function initSignInButton(header)
    {
        const signInButton = header.find(`#${idNames.signInButton}`);

        if (signInButton.length)
        {
            signInButton.one("click", skyward.header.signInButtonClick);
        }
    }

    function initApplicantTrackingSignInButton(header)
    {
        const applicantTrackingSignInButton = header.find(`#${idNames.applicantTrackingSignInButton}`);

        if (applicantTrackingSignInButton.length)
        {
            applicantTrackingSignInButton.one("click", skyward.header.applicantTrackingSignInButtonClick);
        }
    }

    function initHomeButton(header)
    {
        const homeButton = header.find(`#${idNames.portalButton}`);
        homeButton.on("click", skyward.buttonManager.manageButtonClick(function ()
        {
            skyward.header.showHomeButtons($(this));
        }));
    }

    function initTileListLaunchButton(header)
    {
        const tileListLaunchbutton = header.find(`#${idNames.tileListBrowseLaunch}`);

        if (tileListLaunchbutton.length)
        {
            tileListLaunchbutton.one("click", tileListLaunched);
        }

        function tileListLaunched()
        {
            const tileButton = $(this);

            const data = tileButton.data();

            skyward.window.loadContent("full", data.module, data.object, data.screen, null);
        }
    }

    function initCompressModeButton(header)
    {
        const compressModeButton = header.find(`#${idNames.compressMode}`);

        if (compressModeButton.length)
        {
            compressModeButton.one("click", compressButtonClick);
            compressModeButton.debounce("click", saveCompressModeState);
        }

        function compressButtonClick()
        {
            const quickNav = $(`#${idNames.quickNav}`);
            const ribbon = getRibbon();
            const isCompressed = ribbon.hasClass(classNames.ribbonCompressed);

            ribbon.toggleClass(classNames.ribbon, isCompressed);
            ribbon.toggleClass(classNames.ribbonCompressed, !isCompressed);
            quickNav.toggleClass(classNames.displayNone, !isCompressed);
            compressModeButton.attr("aria-checked", isCompressed);
            $(window).trigger("resize");
            compressModeButton.one("click", compressButtonClick);
        }

        function saveCompressModeState()
        {
            const ribbon = getRibbon();
            return $.ajax(
                {
                    url: skyward.global.virtualDir + "Security/Session/UpdateCompressedMode",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { hideGlass: true },
                    data: { compressedMode: ribbon.hasClass(classNames.ribbonCompressed) }
                });
        }
    }

    function initReportAndImportButtons(header)
    {
        const reportSelectorButton = header.find(`#${idNames.reportSelector}`);
        const importSelectorButton = header.find(`#${idNames.importSelector}`);
        const reportAndImportSelectorButton = header.find(`#${idNames.reportAndImportSelector}`);

        if (reportSelectorButton.length)
        {
            reportSelectorButton.on("click", function () { buildReportAndImportList($(this), true, false); });
        }

        if (importSelectorButton.length)
        {
            importSelectorButton.on("click", function () { buildReportAndImportList($(this), false, true); });
        }

        if (reportAndImportSelectorButton.length)
        {
            reportAndImportSelectorButton.on("click", function () { buildReportAndImportList($(this), true, true); });
        }

        function buildReportAndImportList(button, showReports, showImports)
        {
            const reportsAndImports = { reports: [], imports: [] };
            const ajaxActions = [];
            const buttonData = button.data();
            const title = button[0].textContent;

            if (showReports)
            {
                ajaxActions.push($.ajax(
                    {
                        url: skyward.global.virtualDir + "Reporting/Report/BuildReportList",
                        type: "POST",
                        dataType: "JSON",
                        data: buttonData,
                        success: (data) => reportsAndImports.reports = data.menuItems
                    })
                );
            }

            if (showImports)
            {
                ajaxActions.push($.ajax(
                    {
                        url: skyward.global.virtualDir + "SkySys/Import/BuildImportList",
                        type: "POST",
                        dataType: "JSON",
                        data: buttonData,
                        success: (data) => reportsAndImports.imports = data.menuItems
                    })
                );
            }

            $.whenAll(ajaxActions).done(function ()
            {
                const menuItems = [];
                menuItems.push(reportsAndImports.reports);
                menuItems.push(reportsAndImports.imports);

                const options = { anchorTo: button, allowNoButtons: true, useSmallWidth: true, role: "menu" };
                const popupModalLayer = skyward.modalLayer.showInformationBubble(title, menuItems, null, options);
                popupModalLayer.onScreen = true;
            });
        }
    }

function initSkipToMainContent()
{  
    const skipToMainContent = $('.skipToMainContent');
    skipToMainContent.attr('tabindex', 0);

    const focusMain = () =>
    {
        $(document.body).find('[role=main]').focus();
    };

    skipToMainContent.on("click", focusMain);
    skipToMainContent.on('enter', (event) =>
    {
        focusMain();

        event.preventDefault();
        event.stopPropagation();
    });
  }
});